export const uniqueArray = (arr) => arr ? [...new Set(arr)] : [];
